import template from './app.html';
import './app.scss';

let appComponent = {
  template
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js